/**
 * Returns field[lang], falling back to field['ar'] if the requested language
 * is missing, and returning the field itself if it is already a plain string.
 */
export function getLocalized(field, lang) {
  if (!field || typeof field !== 'object' || Array.isArray(field)) return field ?? '';
  return field[lang] ?? field['ar'] ?? '';
}
